import { Button, TextField } from "@mui/material"
import supportService from "../services/support.service"

const DeleteAccount = () => {
    async function onSubmit(e) {
        try {
            e.preventDefault()
            const formData = new FormData(e.target)
            const input = Object.fromEntries(formData.entries())
            await supportService.send(input)
            alert('Запрос на удаление аккаунта отправлен, спасибо за обращение. Мы свяжемся с вами в ближайшее время')
        } catch (ex) {
            console.error(ex)
            alert('Ошибка отправки сообщения')
        }
    }

    return (
        <div>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
                <h3>Служба поддержки</h3>
                <p>Чтобы удалить ваш аккаунт пожалуйтса, заполните все необходимые поля</p>
            </div>
            <div className='support-form-container' style={{ display: 'flex', justifyContent: 'center' }}>
                <form onSubmit={onSubmit} className='support-form' style={{ width: '500px' }}>
                    <div style={{ marginBottom: 10 }}>
                        <TextField fullWidth name='name' placeholder="Ваше имя" />
                    </div>
                    <div style={{ marginBottom: 10 }}>
                        <TextField fullWidth name='email' placeholder="Ваш email" />
                    </div>
                    <div style={{ marginBottom: 10 }}>
                        <TextField fullWidth name='title' placeholder="Номер телефона" />
                    </div>
                    <div style={{ marginBottom: 10 }}>
                        <TextField multiline rows={4} fullWidth name='text' placeholder="Комментария" />
                    </div>
                    <Button fullWidth variant='contained' type='submit'>Удалить аккаунт навсегда</Button>
                </form>
            </div>
        </div>
    )
}

export default DeleteAccount